import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import useClinic from './useClinic'

export const useClinicOfficialName = (id?: string) => {
  const { clinicId } = useConfig()
  const { selectedBookableDateAndTime } = useChoiceState()
  const { data: clinic } = useClinic(id || selectedBookableDateAndTime?.clinicId || clinicId)
  const clinicOfficialName = clinic?.officialName

  return clinicOfficialName
}
